var _defs, _ellipse, _g, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _rect, _rect2, _rect3, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSacredSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 240,
    viewBox: "0 0 220 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "throne-glow",
    cx: 0.5,
    cy: 0.25,
    r: 0.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEAAE",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAAE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold-main",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F9D773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E6B04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "velvet",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F36E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold-side",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F2C55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9781E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft-shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    mode: "normal"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 110,
    rx: 105,
    ry: 90,
    fill: "url(#throne-glow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft-shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 96C36 86 44 78 54 78H68V198H38V96Z",
    fill: "url(#gold-main)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 96C184 86 176 78 166 78H152V198H182V96Z",
    fill: "url(#gold-main)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 70L60 40L82 44L94 16L110 48L126 16L138 44L160 40L150 70H70Z",
    fill: "url(#gold-main)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44L110 8L140 44V166H80V44Z",
    fill: "url(#velvet)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 20L132 46V156H88V46L110 20Z",
    fill: "url(#gold-side)",
    opacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56L110 36L122 56V148H98V56Z",
    fill: "#F4AA55",
    opacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 108,
    r: 16,
    fill: "url(#gold-main)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 108,
    r: 16,
    fill: "url(#gold-main)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 136C28 118 42 104 60 104H72V166H44C34 166 28 154 28 144V136Z",
    fill: "url(#gold-side)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192 136C192 118 178 104 160 104H148V166H176C186 166 192 154 192 144V136Z",
    fill: "url(#gold-side)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 158,
    width: 104,
    height: 56,
    rx: 14,
    fill: "url(#velvet)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 190,
    width: 116,
    height: 38,
    rx: 16,
    fill: "url(#gold-main)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 206,
    width: 96,
    height: 24,
    rx: 12,
    fill: "url(#gold-side)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56 210H80V234C80 238.418 76.4183 242 72 242H64C59.5817 242 56 238.418 56 234V210Z",
    fill: "url(#gold-main)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164 210H140V234C140 238.418 143.582 242 148 242H156C160.418 242 164 238.418 164 234V210Z",
    fill: "url(#gold-main)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacredSeat);
export default __webpack_public_path__ + "static/media/sacred-seat.5d913b55511ce78246c2b21dce87b04b.svg";
export { ForwardRef as ReactComponent };